<template>
  <div id="devmg">
    <el-row>
      <el-button type="primary" icon="el-icon-plus" v-if="isroot" @click="func_adddevic">添加服务</el-button>
    </el-row>
    <el-table :data="tableData" style="width: 1100px" highlight-current-row border>
      <el-table-column type="index" label="编号" width="100"></el-table-column>
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="node_name" label="名字" width="200"></el-table-column>
      <el-table-column prop="nodeip" label="IP地址" width="150"></el-table-column>
      <el-table-column prop="nodeport1" label="端口信息" width="150"></el-table-column>
      <el-table-column prop="detail" label="描述" width="250"></el-table-column>
      <el-table-column v-if="isroot" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click.native.prevent="goDeleteRow(scope.$index, tableData)"
            size="small"
            plain
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="添加节点"
      :visible.sync="dialogVisible_adddevice"
      width="400px"
      :before-close="handleClose_adddevice"
    >
      <div style="margin-top: 15px;">
        <el-input placeholder="NODE NAME" v-model="node_name">
          <template slot="prepend">[节点名字]:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="XXX.XXX.XXX.XXX" v-model="node_ip">
          <template slot="prepend">[节 点 I P ]:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="3333" v-model="node_port">
          <template slot="prepend">[服务端口]:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="6002" v-model="node_port4">
          <template slot="prepend">[数据端口]:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="6003" v-model="node_port5">
          <template slot="prepend">[控制端口]:</template>
        </el-input>
      </div>

      <div style="margin-top: 15px;">
        <el-input placeholder="6006" v-model="node_port3">
          <template slot="prepend">[音频端口]:</template>
        </el-input>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="Note info" v-model="node_detail">
          <template slot="prepend">[节点备注]:</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_addone_device">添加节点</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible_save_back"
      width="30%"
      :before-close="handleClose_save_back"
    >
      <span>1分钟后生效 等待一下</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="open5">配置详情</el-button>
        <el-button type="primary" @click="dialogVisible_save_back = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
export default {
  data() {
    return {
      tableData: [],
      dialogVisible_adddevice: false,
      node_name: "",
      node_detail: "",
      node_ip: "",
      isroot: false,
      node_port: 3333,
      node_port5: 6003,
      node_port3: 6006,
      node_port4: 6002,
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false
    };
  },
  created() {
    this.reflash_devlist();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {
    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该服务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    open5() {
      this.$alert(this.save_backdata, "配置详情", {
        dangerouslyUseHTMLString: false
      });
    },
    handleClose_save_back() {},
    func_addone_device() {
      this.dialogVisible_adddevice = false;
      if (this.node_name.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "节点名字不能为空",
          showClose: true
        });
        return;
      }
      if (this.node_detail.trim() == "") {
        this.node_detail = this.node_name.trim() + "没有备注信息";
      }
      if (this.node_ip.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "节点IP不正确",
          showClose: true
        });
        return;
      }
      if (this.node_port == 0) {
        this.$notify.success({
          title: "Info",
          message: "节点端口不正确",
          showClose: true
        });
        return;
      }

      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeip", this.node_ip.trim());
      data.append("detail", this.node_detail.trim());
      data.append("nodename", this.node_name.trim());
      data.append("port1", this.node_port);
      data.append("port2", 6000);
      data.append("port3", this.node_port3);
      data.append("port4", this.node_port4);
      data.append("port5", this.node_port5);
      axios
        .post("/add_user_node.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "添加成功",
                showClose: false
              });
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加节点出现异常检查是否重复添加",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    func_adddevic() {
      this.dialogVisible_adddevice = true;
    },
    func_savedevic() {
      const loading = this.$loading({
        lock: true,
        text: "Processing",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector(".div1")
      });
      //     setTimeout(() => {
      //       loading.close();
      //     }, 2000);
      axios
        .get("/create_config.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.save_backdata = res.data.config;
              this.dialogVisible_save_back = true;

              loading.close();
            } else {
              this.$notify.success({
                title: "Info",
                message: "哪里出现错误了",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    deleteRow(index, rows) {
      let node_ip = rows[index].nodeip;

      axios
        .get("/del_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            nodeip: node_ip
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    editRow(index, rows) {
      console.log(index, rows);
      this.id = rows[index].id;
      this.node_name = rows[index].node_name;
      this.node_ip = rows[index].nodeip;
      this.node_port = rows[index].nodeport1;
      this.node_detail = rows[index].detail;
      this.dialogVisible_adddevice2 = true;
    },
    handleClose_adddevice() {
      this.dialogVisible_adddevice = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflash_devlist: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.dataJson;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px auto;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/nodemg.vue